export const validationConfig = (config) => {
    return Object.keys(config).reduce((previousValue, currentValue) => {
        if(config[currentValue].validation) {
            previousValue[currentValue] = config[currentValue].validation
        }
        return previousValue
    }, {  })
}